import { buildViuRegionsFromEnv, buildViuCarrierAsnMapFromEnv } from './viuRegionsFromEnv'

export default {
  appVersion: '2.2.5',
  applicationKey: '84e1d3ec-8efe-45e1-85ef-59ee1afafe42',
  applicationSecret: '7k0l2l6Jtmofvxle51QQVR5d',
  sabBaseUrl: 'https://pkp-qa.sandboxkids.io',
  vindiBaseUrl: 'https://sandbox-app.vindi.com.br',
  vindiApiSecret: 'OHdHczFMY1lNMmEzVHd4bVc5anMzYU9JVUdHTkpWNjQyX2ZONnQxTFJqQTo=',
  appsBuilderBaseUrl: 'http://localhost:8000',
  contentTreeBaseUrl: 'https://cdn.playkidsapp.com/playkids_web_homolog',
  peanutbutterBaseUrl: 'http://localhost:8088',
  fasterAnalyticsBaseUrl: 'https://api.fstr.rocks',
  skylerBaseUrl: 'https://skyler.pkds.it',
  viacepBaseUrl: 'https://viacep.com.br',
  recaptchaKey: '6LdZ2Q0lAAAAAChJeX43D4HixmTFrGbA6Q-cw_sm',
  facebookAppId: '480872519271554',
  brazeApiKey: '408c36f6-7cf4-4c15-b9d2-90549252c9d8',
  excludedSkus: [],
  environment: 'homolog',
  bucket: 'https://assets.playkidsapp.com/offers',
  integrationACL: {
    baseUrl: 'https://playhub-hmg.kwsdk.io',
    clientId: '',
    clientSecret: ''
  },
  /**
   * Viu / Veniso header enrichment (HE) — per-region outbound URL + mobile HE return (`?hash=`).
   * Regions: `VUE_APP_VIU_REGIONS_JSON` (see `viuRegionsFromEnv.js`) or legacy flat `VUE_APP_VIU_*` (Ghana only).
   */
  viu: {
    enabled: process.env.VUE_APP_VIU_ENABLED === 'true',
    /** When true, eligible mobile users in a configured region are sent to that region's Viu HE URL. */
    clientRedirect: process.env.VUE_APP_VIU_CLIENT_REDIRECT === 'true',
    /** Shared AES for all regions (`VUE_APP_VIU_AES_KEY` / `VUE_APP_VIU_AES_IV`). */
    aesKey: process.env.VUE_APP_VIU_AES_KEY || '',
    aesIv: process.env.VUE_APP_VIU_AES_IV || '',
    partnerErrorPath: process.env.VUE_APP_VIU_PARTNER_ERROR_PATH || '/header-enrichment/error',
    /** Per-region: URL, product, dial, bypass, carrier — see `viuRegionsFromEnv.js`. */
    regions: buildViuRegionsFromEnv(),
    /** ASN → carrier map for disambiguating operators sharing a country (e.g. MTN/Telecel Ghana). */
    carrierAsnMap: buildViuCarrierAsnMapFromEnv(),
    xApiKey: process.env.VUE_APP_VIU_X_API_KEY || '',
    /**
     * Local QA: when set and the URL already has `?hash=`/`?he_hash=` from HE, use this ciphertext
     * instead (same AES as app). Never set in production. See `resolveViuHeHashForProcessing`.
     */
    debugHashOverride: process.env.VUE_APP_VIU_DEBUG_HASH_OVERRIDE || '',
    /** Local only: allow `?hash=` HE callback on desktop browsers (prod stays phone/tablet only). */
    allowDesktopHeCallback: process.env.VUE_APP_VIU_ALLOW_DESKTOP_HE_CALLBACK === 'true',
    /**
     * Kill switch: when a `?hash=` fails to decrypt/parse, fall back to the HE gateway redirect
     * instead of showing the error page (see `App.vue` `finishViuHashFlow` catch block). Defaults
     * on; set VUE_APP_VIU_HASH_DECODE_FALLBACK_ENABLED=false to revert instantly to the old
     * fail-to-error-page behavior without touching the decode/redirect code itself.
     */
    hashDecodeFallbackEnabled: process.env.VUE_APP_VIU_HASH_DECODE_FALLBACK_ENABLED !== 'false',
    /**
     * Kill switch: when a decrypted HE payload has no MSISDN (any status — the partner's sample
     * reports 121, not 101), re-run HE against the region named by the payload's `productcode`
     * instead of showing the partner error page (see `retryViuHeForMissingMsisdn`). Defaults on;
     * set to `false` to restore the error page.
     */
    missingMsisdnRetryEnabled: process.env.VUE_APP_VIU_MISSING_MSISDN_RETRY_ENABLED !== 'false'
  }
}
